import { Record } from "react-admin";
export interface StaffUser {
    email: string;
    role: StaffUserRole;
    name: string | "";
    surname: string | "";
    isBlocked: boolean;
    startDate: string;
    skype: string | "";
    permissions: Array<RightsRow>;
    id: string,
    _id?: string
};
export interface RightsRow {
    page: string,
    rights: {
        View: boolean;
        Update: boolean;
        Delete: boolean
    }
}
export enum StaffUserRole {
    SuperAdmin = "superAdmin",
    Admin = "admin",
    Moderatore = "moderator"
}